import { handleCustomUDL } from "@utils/UDLUtils";

const wrapperSelector = ".article-content .comp-section .outer-container";
const loginWallFadeoutSelector = ".article-content__login-fadeout";
const loginButtonSelector = ".article-content__login-button";
const registerButtonSelector = ".article-content__register-button";
const fadeoutOuterContainerSelector = ".article-content__login-fadeout-outer-container";
const fadeoutOuterContainerVisibleClass = "article-content__login-fadeout-outer-container--visible";
const hideableTags = ["SPAN", "DIV", "P", "H1", "H2", "H3", "H4", "H5", "H6", "LI", "UL", "OL"];

export class ArticleContent {
  private ctx: HTMLElement;
  private abortController: AbortController | null = null;

  constructor(element: HTMLElement) {
    this.ctx = element;
  }

  init(): this {
    this.applyLoginWall();
    this.applyUDLs();
    return this;
  }

  private applyLoginWall(): void {
    const wrapper = this.ctx.querySelector<HTMLElement>(wrapperSelector);
    const loginWallFadeOut = this.ctx.querySelector<HTMLElement>(loginWallFadeoutSelector);
    const fadeoutOuterContainer = this.ctx.querySelector<HTMLElement>(fadeoutOuterContainerSelector);
    const isLoggedIn = document.cookie.includes("SERVICES_ACCESS_TOKEN=");
    const isPremiumArticle = this.ctx.getAttribute("data-premium-article") === "true";
    const isEditMode = this.ctx.getAttribute("data-is-editmode") === "true";

    if (!isPremiumArticle || isLoggedIn || isEditMode || !wrapper || !loginWallFadeOut || !fadeoutOuterContainer) return;

    const minContentHeight = 200;
    const maxContentHeight = 600;
    const parsedWrapper: Element[] = [];

    function parseWrapper(element: Element): void {
      for (const child of Array.from(element.children)) {
        parsedWrapper.push(child);
        if (child.children.length > 0) parseWrapper(child);
      }
    }
    parseWrapper(wrapper);

    for (let i = parsedWrapper.length - 1; i > 0; i--) {
      const child = parsedWrapper[i] as HTMLElement;
      if (wrapper.offsetHeight - child.offsetHeight <= minContentHeight) break;
      if (hideableTags.includes(child.tagName)) {
        child.style.display = "none";
      }
      if (wrapper.offsetHeight <= maxContentHeight) break;
    }

    const fadeOutOffset = wrapper.offsetHeight;
    loginWallFadeOut.style.top = `-${fadeOutOffset}px`;
    loginWallFadeOut.style.height = `${fadeOutOffset}px`;
    fadeoutOuterContainer.classList.add(fadeoutOuterContainerVisibleClass);
  }

  private applyUDLs(): void {
    const abortController = this.abortController ?? new AbortController();
    this.abortController = abortController;
    const { signal } = abortController;
    this.ctx
      .querySelector<HTMLElement>(loginButtonSelector)
      ?.addEventListener("click", () => handleCustomUDL("login_wall_button", { button: "Login" }), { signal });
    this.ctx
      .querySelector<HTMLElement>(registerButtonSelector)
      ?.addEventListener("click", () => handleCustomUDL("login_wall_button", { button: "Sign Up" }), { signal });
  }

  destroy(): void {
    this.abortController?.abort();
    this.abortController = null;
  }

  static initAll(): void {
    document
      .querySelectorAll<HTMLElement>('[data-component="article-content"]')
      .forEach((el) => new ArticleContent(el).init());
  }
}
